/**
 * Errors Constants
 * @export ErrorsConstants
 */
export const ErrorsConstants = {
    CLASSNAME: 'ErrorsComponent'
}